import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import Link from 'components/shared/Link'
import SeparatedList from 'components/shared/SeparatedList'
import DateTitle from 'components/shared/DateTitle'
import { FormattedMessage } from 'react-intl'
import { RemoteIdType } from 'routes/selfcare/views/SelfcareSummary/index'
import { formatPrice } from 'helpers/helpers'
import { useAppSelector } from 'store/hooks'
import { getFormattedDate } from 'helpers/dates'
import { SelfcareText } from './style'

interface PackagesRowProps {
    mode?: 'summary' | 'reservation'
    handleEdit?: (remoteId: RemoteIdType) => void
}

const SelfcarePackages = ({ mode, handleEdit }: PackagesRowProps) => {
    const { ticketsBundles } = useAppSelector((state) => state.selfcare)

    return (
        <Box isFullWidth gap={24} mb={[24, 48]}>
            <Box
                direction="row"
                align="center"
                justify="space-between"
                isFullWidth
            >
                <Text variant="heading3" color="secondary_700">
                    <FormattedMessage
                        id="selfcare.bundles.section_caption"
                        defaultMessage="Pakiety"
                    />
                </Text>
                {mode === 'reservation' && (
                    <Link
                        variant="primary"
                        textVariant="bodySmallStrong"
                        icon={null}
                        // path={`${process.env.REACT_APP_API_URL}api/${language}/selfcare/attachment/ticket`}
                        data-testid="selfcare-button-download-package"
                    >
                        <FormattedMessage
                            id="selfcare.download_tickets"
                            defaultMessage="Pobierz bilety"
                        />
                    </Link>
                )}
                {mode === 'summary' && handleEdit && (
                    <Link
                        variant="gray"
                        icon={null}
                        onClick={() => handleEdit('manage-bundles')}
                        data-testid="selfcare-summary-button-edit-bundles"
                    >
                        <FormattedMessage
                            id="selfcare.edit"
                            defaultMessage="Edytuj"
                        />
                    </Link>
                )}
            </Box>
            <SeparatedList
                direction="column"
                gap={[16, 24]}
                isFullWidth
                borderWidth={2}
                borderColor="grayscale_300"
                hasLastItemBorder={false}
                mt={[16, 24]}
            >
                {ticketsBundles
                    ?.slice()
                    ?.sort((dayA, dayB) => {
                        const dateA = new Date(dayA.original.detail.date)
                        const dateB = new Date(dayB.original.detail.date)

                        return dateA.getTime() - dateB.getTime()
                    })
                    .map(
                        (
                            {
                                original: { detail, name, descriptions, price },
                                changes,
                                changeType,
                            },
                            index
                        ) => {
                            const isCompleted =
                                !!changeType && changeType === 'return'

                            const description = descriptions?.length
                                ? descriptions[0].description
                                      ?.split('(')
                                      .join('<br>(')
                                : ''

                            return (
                                <Box
                                    key={`${detail.boxId}-${index}`}
                                    gap={[16, 24]}
                                >
                                    <DateTitle
                                        index={index + 1}
                                        date={
                                            changes
                                                ? changes.detail.date
                                                : detail.date
                                        }
                                    />
                                    <Box
                                        direction="row"
                                        justify="space-between"
                                        isFullWidth
                                    >
                                        <Box>
                                            <Box direction="row" align="center">
                                                <SelfcareText
                                                    variant="bodySmall"
                                                    color="grayscale_900"
                                                    mr={6}
                                                    isCompleted={isCompleted}
                                                >
                                                    {name}
                                                </SelfcareText>
                                                {changes &&
                                                    changes.detail.date !==
                                                        detail.date && (
                                                        <>
                                                            (
                                                            <SelfcareText
                                                                variant="bodySmall"
                                                                color="primary_500"
                                                                isCompleted={
                                                                    isCompleted
                                                                }
                                                            >
                                                                {getFormattedDate(
                                                                    {
                                                                        date: detail.date,
                                                                        withYear:
                                                                            true,
                                                                    }
                                                                )}
                                                            </SelfcareText>
                                                            )
                                                        </>
                                                    )}
                                            </Box>
                                            <Box mt={4}>
                                                <SelfcareText
                                                    key={`description-${index}`}
                                                    variant="bodySmall"
                                                    color="grayscale_700"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            description || '',
                                                    }}
                                                    isCompleted={isCompleted}
                                                />
                                            </Box>
                                        </Box>
                                        {changes && !!changes.price && (
                                            <SelfcareText
                                                hasNoWrap
                                                variant="bodySmallStrong"
                                                align="right"
                                                color="primary_500"
                                                isCompleted={isCompleted}
                                            >
                                                {formatPrice(
                                                    changes.price,
                                                    true
                                                )}
                                            </SelfcareText>
                                        )}
                                        {!!price && !changes?.price && (
                                            <SelfcareText
                                                hasNoWrap
                                                variant="bodySmallStrong"
                                                align="right"
                                                color="secondary_500"
                                                isCompleted={isCompleted}
                                            >
                                                {formatPrice(price, true)}
                                            </SelfcareText>
                                        )}
                                    </Box>
                                </Box>
                            )
                        }
                    )}
            </SeparatedList>
        </Box>
    )
}

export default SelfcarePackages
